import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyMenuTrigger } from '@angular/material/legacy-menu';

@Component({
  selector: 'mode-accessor-search-input',
  templateUrl: './accessor-search-input.component.html',
  styleUrls: ['./accessor-search-input.component.scss'],
})
export class AccessorSearchInputComponent {
  @ViewChild(MatLegacyMenuTrigger) trigger: MatLegacyMenuTrigger;

  @Input() placeholder = '';
  @Input() disabled = false;

  @Output() valueChanged = new EventEmitter<any>();

  inputChange(event) {
    const targetInputValue = event.target.value;
    this.valueChanged.emit(targetInputValue);
    // if for whatever reason the menu is not open while the user typed input
    if (!this.trigger.menuOpen) {
      // then open the menu
      this.trigger.openMenu();
    }
  }
}
